import React, {useState}  from "react";
import {useDealContext} from "../../contexts/DealContext";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import CurrencyInput from "react-currency-input-field";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import useTaxStateHook from "../../hooks/useTaxStateHook";

export const DealPageTaxItem = ({ taxItem }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {updateDealResponse} = useDealContext()
    const [taxState, setTaxStateWithUpdate] = useTaxStateHook(taxItem)


    const isLoading = updateDealResponse?.loading

    return (
        <TableRow
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                width={'25%'}
                align="left"
            >
                {taxState.name}
            </TableCell>
            {
                !isTabletOrMobile &&
                <TableCell
                    className={'DealPageFee fee-name'}
                    scope="row"
                    size={'small'}
                    width={'25%'}
                    align="right"
                >
                    <CurrencyInput
                        className={'payment-row_value disabled'}
                        prefix="$"
                        value={taxState.taxable_amount}
                        disabled={true}
                    />
                </TableCell>
            }
            <TableCell
                className={'DealPageFee'}
                align="right"
                size={'small'}
                width={'10%'}
            >
                <Switch
                    disabled={isLoading}
                    checked={taxState.is_capped}
                    onChange={() => {
                        setTaxStateWithUpdate({is_capped: !taxState.is_capped}, true)
                    }}
                />
            </TableCell>
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'10%'}
            >
                <CurrencyInput
                    className={'payment-row_value disabled'}
                    prefix="$"
                    value={taxState.amount}
                    disabled={true}
                />
            </TableCell>
        </TableRow>
    )
}